// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__1KbF1","close":"styles_close__2g8L1"};